import { Configuration } from 'app/components/metro-line/types';
import { scrollIntoView } from 'app/infrastructure/platform/browser-dom';
import * as navigate from 'app/area/shared/navigation';

export const getSectionId = <SectionType>(section: SectionType) => `metro-line-section-archor-${section}`;

export const isTabsMode = (): boolean => {
  if (!window || !window.location || !window.location.pathname) {
    return false;
  }

  const pathname = window.location.pathname.split('/');
  return pathname ? pathname[pathname.length - 2] === 'section' : false;
};

export const getInvalidSection = <SectionType>(configuration: Configuration<SectionType>[]): Configuration<SectionType> =>
  configuration && configuration.find(item => !item.isValid);

export const redirectToInvalidSection = <SectionType>(invalidSection: Configuration<SectionType>): void => {
  if (!invalidSection || !invalidSection.ref || !invalidSection.ref.current) {
    return;
  }

  isTabsMode() ? navigate.toMetroLineSection(invalidSection.url) : scrollIntoView(invalidSection.ref.current, { behavior: 'smooth' });
};
